import React from 'react';
import ProfileMenu from './ProfileMenu';
import { URL } from '../variables';
import { connect } from 'react-redux';
import { getLanguageTexts, getSelectedLanguage, languageOptions, setSelectedLanguage } from '../language';


class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = { selectedLanguage: getSelectedLanguage() };
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleLanguageEvent = this.handleLanguageEvent.bind(this);
    }

    componentDidMount() {
        window.addEventListener('external_camera_language_change', this.handleLanguageEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('external_camera_language_change', this.handleLanguageEvent);
    }

    handleLanguageChange(event) {
        this.setState({ selectedLanguage: setSelectedLanguage(event.target.value) });
    }

    handleLanguageEvent(event) {
        this.setState({ selectedLanguage: event.detail || getSelectedLanguage() });
    }

    render() {
        const t = getLanguageTexts(this.state.selectedLanguage);
        return (
            <div className="external-camera-header">
                <div className="external-camera-header-logo">
                    {this.props.faculdade.logo != null && <a className="logo">
                        <img src={this.props.faculdade.logo} alt="" />
                    </a>}
                </div>
                <nav className="external-camera-header-actions">
                    <label className="external-camera-preference-language external-camera-header-language">
                        <i className="mdi mdi-web"></i>
                        <select value={this.state.selectedLanguage} onChange={this.handleLanguageChange} aria-label={t.language_label}>
                            {languageOptions.map((item) => (
                                <option key={item.value} value={item.value}>{item.value}</option>
                            ))}
                        </select>
                    </label>
                    <ul className="navbar-right d-flex list-inline mb-0">
                        <ProfileMenu />
                    </ul>
                </nav>
            </div>

        );
    }


}

const mapsStateToProps = (state) => (
    {
        faculdade: state.AppReducer.faculdade
    }
);

export default connect(mapsStateToProps, {})(Header);
